<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{ anwendungsname }}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      <h4>Quellenverzeichnisse</h4>
      <p>
        Hier sind die Quellenverzeichnisse der Institutionen aufgelistet, die
        die Indikatoren-Steckbriefe erstellt haben. Die den jeweiligen Indikator
        bearbeitende Institution finden Sie am Schluss des Indikator-Steckbriefs
        (pdf).
      </p>
    </div>
  </div>
  <mat-card>
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-10 text-download">
            Rind: Thünen-Institut für Ökologischen Landbau und Statistisches
            Bundesamt
          </div>

          <div class="col-md-2 text-right">
            <button
              mat-raised-button
              class="custom-btn"
              color="primary"
              (click)="downloadPdfRind()"
            >
              Download
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-10 text-download">
            Schwein: Christian-Albrechts-Universität zu Kiel und Statistisches
            Bundesamt
          </div>

          <div class="col-md-2 text-right">
            <button
              mat-raised-button
              class="custom-btn"
              color="primary"
              (click)="downloadPdfSchwein()"
            >
              Download
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-10 text-download">
            Geflügel: Hochschule Osnabrück und Statistisches Bundesamt
          </div>

          <div class="col-md-2 text-right">
            <button
              mat-raised-button
              class="custom-btn"
              color="primary"
              (click)="downloadPdfGefluegel()"
            >
              Download
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-10 text-download">
            Transport und Schlachtung: Friedrich-Loeffler-Institut und
            Statistisches Bundesamt
          </div>

          <div class="col-md-2 text-right">
            <button
              mat-raised-button
              class="custom-btn"
              color="primary"
              (click)="downloadPdfTuS()"
            >
              Download
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-10 text-download">
            Tierwohl-Begleitindikatoren: Thünen-Institut für Betriebswirtschaft
          </div>

          <div class="col-md-2 text-right">
            <button
              mat-raised-button
              class="custom-btn"
              color="primary"
              (click)="downloadPdfSOE()"
            >
              Download
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-10 text-download">
            Regenbogenforelle und Karpfen, inkl. Transport und Schlachtung:
            Tierärztliche Hochschule Hannover und Thünen-Institut für
            Fischereiökologie
          </div>
          <div class="col-md-2 text-right">
            <button
              mat-raised-button
              class="custom-btn"
              color="primary"
              (click)="downloadPdfAquakultur()"
            >
              Download
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-10 text-download">
            Schaf und Ziege: Humboldt-Universität zu Berlin und Statistisches
            Bundesamt
          </div>
          <div class="col-md-2 text-right">
            <button
              mat-raised-button
              class="custom-btn"
              color="primary"
              (click)="downloadPdfSchatzi()"
            >
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  </mat-card>

  <div class="spacer"></div>
  <mat-card>
    <div class="row">
      <div class="col-md-2">
        <button
          (click)="goBack()"
          mat-raised-button
          color="primary"
          class="custom-btn mt-3"
          type="button"
        >
          <fa-icon [icon]="faArrowLeft" class="mx-1 icon-arrow"></fa-icon>
          Zurück
        </button>
      </div>
    </div>
  </mat-card>
</div>
<div class="spacer"></div>
